<template>
<div>
	<v-dialog
		v-model="dialog"
		width="500"
		persistent
	>
		<v-btn
			slot="activator"
			color="indigo"
			dark
		>
			{{$t('user.change_password')}}
		</v-btn>

		<v-card>
			<v-card-title
				class="headline light-blue darken-1 white--text"
				primary-title
			>
				{{$t('user.password')}}
			</v-card-title>

			<v-card-text>
				<v-container grid-list-lg>
					<v-layout>
						<v-flex md12>
							<v-layout column>
								<v-form ref="form" v-model="valid" lazy-validation>
									<v-flex>
										<v-text-field
											:rules="rules.password"
											:label="$t('user.new_password')"
											v-model="formData.password"
											:append-icon="show1 ? 'visibility_off' : 'visibility'"
											@click:append="show1 = !show1"
											:type="show1 ? 'text' : 'password'"
										/>
									</v-flex>
									<v-flex>
										<v-text-field
											:rules="rules.repeatPassword"
											:label="$t('user.repeat_password')"
											v-model="formData.repeatPassword"
											:append-icon="show2 ? 'visibility_off' : 'visibility'"
											@click:append="show2 = !show2"
											:type="show2 ? 'text' : 'password'"
										/>
									</v-flex>
								</v-form>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>

			<v-divider />

			<v-card-actions>
				<v-spacer />
				<v-btn
					color="red light-1"
					flat
					@click="cancel"
				>
					{{$t('common.cancel')}}
				</v-btn>
				<ConfirmDialog @accept="save" v-bind="propConfirm">
					{{$t('common.confirm')}}
				</ConfirmDialog>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import ConfirmDialog from '../../components/ConfirmDialog'
import { TEMPLATE_CHANGE_PASSWORD } from '../../constants'
import { notify } from '../../utils/notifications'

export default {
	components: {
		ConfirmDialog
	},
	data: vm => ({
		dialog: false,
		valid: true,
		show1: false,
		show2: false,
		rules: {
			password: [v => !!v || vm.$t('common.field_required')],
			repeatPassword: [
				v => !!v || vm.$t('common.field_required'),
				v =>
				vm.formData.password === vm.formData.repeatPassword ||
				vm.$t('user.password_not_match'),
			]
		},
		formData: { ...TEMPLATE_CHANGE_PASSWORD },
		propConfirmDialog: {
			message: vm.$t('user.confirm_password'),
			title: vm.$t('user.confirm_password_title'),
			btnProps: {
				color: 'green lighten-2',
				flat: true
			}
		}
	}),
	computed: {
		propConfirm() {
			return {
				...this.propConfirmDialog,
				message: this.$t('user.confirm_password')
			}
		}
	},
	methods: {
		...mapActions({
			changePassword: 'users/changePassword'
		}),
		save() {
			if (!this.$refs.form.validate()) {
				return false
			}
			this.changePassword({ ...this.formData }).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.changed', { type: this.$t('user.password') })
				})
			})
			this.cancel()
		},
		cancel() {
			this.dialog = false
			this.$refs.form.reset()
			this.clearForm()
		},
		clearForm() {
			this.formData = { ...TEMPLATE_CHANGE_PASSWORD }
		}
	}
}
</script>
